import { render, staticRenderFns } from "./pddInfoFormDialog.vue?vue&type=template&id=aff5369c"
import script from "./pddInfoFormDialog.vue?vue&type=script&lang=js"
export * from "./pddInfoFormDialog.vue?vue&type=script&lang=js"
import style0 from "./pddInfoFormDialog.vue?vue&type=style&index=0&id=aff5369c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports